import api from "@/utils/api";
import config from "@/config.js";

import { deserializeDate, timeSince } from "@/utils/time";

const state = {
  repoActivities: [],
  rollbackRequest: {},
  deployRequest: {},

  repoBranches: {
    web: [],
    api: [],
    codegen: [],
  },

  canaryActivities: {
    web: [],
    api: [],
    codegen: [],
  },
  repoLinks: {
    web: [],
    api: [],
    codegen: [],
  },
};

const mutations = {
  setRepoActivities(state, data) {
    state.repoActivities = data;

    state.repoActivities.map(
      (activity) => (activity.date = timeSinceFormat(activity.date))
    );
  },

  setRollbackRequestStatus(state, data) {
    state.rollbackRequest = data;
  },

  setRepoBranches(state, data) {
    const { branches, repoName } = data;

    if (repoName === "anima-api") {
      state.repoBranches.api = branches;
      return;
    }

    if (repoName === "anima-web") {
      state.repoBranches.web = branches;
      return;
    }

    state.repoBranches.codegen = branches;
  },

  setCanaryActivities(state, activities) {
    activities.map(
      (activity) => (activity.date = timeSinceFormat(activity.created_at))
    );

    state.canaryActivities = activities;
  },

  setDeployRequestStatus(state, data) {
    state.deployRequest = data;
  },

  setRepoLinks(state, links) {
    state.repoLinks.api = links["anima-api"];
    state.repoLinks.web = links["anima-web"];
    state.repoLinks.codegen = links["anima-codegen"];
  },
};

const actions = {
  async getRepoActivities({ commit }, repoName) {
    try {
      commit("setLoading", "repoActivities");
      const { data } = await api.get(
        `${config.API_BASE_URL}/admin/devops/images?repo_name=${repoName}`
      );
      if (data) {
        commit("setRepoActivities", data.data);
        commit("unsetLoading", "repoActivities");
        return;
      }
      commit("unsetLoading", "repoActivities");
    } catch {
      commit("unsetLoading", "repoActivities");
    }
  },

  async rollbackActivity({ commit }, activityDetails) {
    try {
      commit("setLoading", "repoActivities");
      const { data } = await api.post(
        `${config.API_BASE_URL}/admin/devops/rollback`,
        {
          repo_name: activityDetails.repo,
          commit_sha: activityDetails.tag,
        }
      );
      if (data) {
        commit("setRollbackRequestStatus", data);
        commit("unsetLoading", "repoActivities");
        return;
      }
      commit("unsetLoading", "repoActivities");
    } catch {
      commit("unsetLoading", "repoActivities");
    }
  },

  async getRepoBranches({ commit }, repoName) {
    try {
      commit("setLoading", "repoBranches");
      const { data } = await api.get(
        `${config.API_BASE_URL}/admin/devops/branches?repo_name=${repoName}`
      );
      if (data) {
        commit("setRepoBranches", { branches: data.data, repoName });
        commit("unsetLoading", "repoBranches");
        return;
      }
      commit("unsetLoading", "repoBranches");
    } catch {
      commit("unsetLoading", "repoBranches");
    }
  },

  async getCanaryActivities({ commit }, canaryName) {
    try {
      commit("setLoading", "canaryActivities");
      const { data } = await api.get(
        `${config.API_BASE_URL}/admin/devops/get_activities_of_a_canary?canary_name=${canaryName}`
      );
      if (data) {
        commit("setCanaryActivities", data.data);
        commit("setRepoLinks", data.links);
        commit("unsetLoading", "canaryActivities");
        return;
      }
      commit("unsetLoading", "canaryActivities");
    } catch {
      commit("unsetLoading", "canaryActivities");
    }
  },

  async deployBranch({ commit }, payload) {
    try {
      commit("setLoading", "deploy");
      const { data } = await api.post(
        `${config.API_BASE_URL}/admin/devops/canary/set_branch`,
        payload
      );
      if (data) {
        commit("setDeployRequestStatus", data);
        commit("unsetLoading", "deploy");
        return;
      }
      commit("unsetLoading", "deploy");
    } catch {
      commit("unsetLoading", "deploy");
    }
  },
};

const timeSinceFormat = (date) => `${timeSince(deserializeDate(date))} ago`;

const getters = {
  repoActivities: (s) => s.repoActivities,
  rollbackRequest: (s) => s.rollbackRequest,
  repoBranches: (s) => s.repoBranches,
  repoLinks: (s) => s.repoLinks,
  canaryActivities: (s) => s.canaryActivities,
  deployRequest: (s) => s.deployRequest,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
